// removed by extract-text-webpack-plugin
module.exports = {"root":"header__root","container":"header__container","ad":"header__ad","videoPlayerContain":"header__videoPlayerContain","streamingNow":"header__streamingNow"};


//////////////////
// WEBPACK FOOTER
// ./src/show-index/containers/header/styles.less
// module id = 481
// module chunks = 3